/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Toast_Setup_Code_SentInputs */

const en_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If this email can be claimed, we sent a setup code. Check your inbox and enter it below.`)
};

const es_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si este correo se puede vincular a una cuenta, enviamos un código de configuración. Revisa tu bandeja e introdúcelo abajo.`)
};

const de_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falls diese E-Mail-Adresse mit einem Konto verknüpft werden kann, haben wir einen Einrichtungscode gesendet. Prüfen Sie Ihren Posteingang und geben Sie ihn unten ein.`)
};

const zh_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果该邮箱可以关联到账户，我们已发送设置码。请查收邮件并在下方输入。`)
};

const ar_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إذا كان بالإمكان المطالبة بهذا البريد الإلكتروني، فقد أرسلنا رمز إعداد. تحقّق من بريدك الوارد وأدخله أدناه.`)
};

const fr_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si cet e-mail peut être associé à un compte, nous avons envoyé un code de configuration. Vérifiez votre boîte de réception et saisissez-le ci-dessous.`)
};

const vi_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nếu email này có thể được xác nhận, chúng tôi đã gửi mã thiết lập. Hãy kiểm tra hộp thư và nhập mã bên dưới.`)
};

const sw_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ikiwa barua pepe hii inaweza kuunganishwa na akaunti, tumekutumia msimbo wa kuweka akaunti. Angalia kikasha chako na uuweke hapa chini.`)
};

const th_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`หากอีเมลนี้สามารถใช้ยืนยันบัญชีได้ เราได้ส่งรหัสตั้งค่าไปแล้ว โปรดตรวจสอบกล่องจดหมายและกรอกรหัสด้านล่าง`)
};

const bs_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ako se ova e-mail adresa može povezati s računom, poslali smo kod za postavljanje. Provjerite inbox i unesite ga ispod.`)
};

const ja_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このメールアドレスが登録可能な場合は、設定コードをお送りしました。受信トレイを確認し、下に入力してください。`)
};

const ko_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`등록 가능한 이메일이라면 설정 코드를 보내 드렸습니다. 받은편지함을 확인한 후 아래에 입력하세요.`)
};

const pt_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se este e-mail puder ser vinculado, enviamos um código de configuração. Confira sua caixa de entrada e digite-o abaixo.`)
};

const it_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se questa email può essere associata, ti abbiamo inviato un codice di configurazione. Controlla la posta in arrivo e inseriscilo qui sotto.`)
};

const sv_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om den här e-postadressen kan kopplas till ett konto har vi skickat en aktiveringskod. Kolla inkorgen och ange koden nedan.`)
};

const nl_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als dit e-mailadres aan een account kan worden gekoppeld, hebben we een activatiecode gestuurd. Controleer je inbox en vul de code hieronder in.`)
};

const da_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis denne e-mailadresse kan tilknyttes en konto, har vi sendt en aktiveringskode. Tjek din indbakke, og indtast koden nedenfor.`)
};

const nb_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvis denne e-postadressen kan knyttes til en konto, har vi sendt en aktiveringskode. Sjekk innboksen din og skriv inn koden nedenfor.`)
};

const fi_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jos tämä sähköpostiosoite voidaan liittää tiliin, lähetimme aktivointikoodin. Tarkista saapuneet viestit ja anna koodi alle.`)
};

const pl_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeśli ten adres e-mail można przypisać do konta, wysłaliśmy kod aktywacyjny. Sprawdź skrzynkę odbiorczą i wpisz go poniżej.`)
};

const ru_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Если этот адрес электронной почты можно привязать к аккаунту, мы отправили код активации. Проверьте почту и введите код ниже.`)
};

const tr_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu e-posta adresi bir hesaba bağlanabiliyorsa etkinleştirme kodu gönderdik. Gelen kutunuzu kontrol edin ve kodu aşağıya girin.`)
};

const hi_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अगर यह ईमेल किसी खाते से जोड़ा जा सकता है, तो हमने एक सेटअप कोड भेजा है। अपना इनबॉक्स देखें और कोड नीचे दर्ज करें।`)
};

const id_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika email ini dapat ditautkan ke akun, kami telah mengirim kode aktivasi. Periksa kotak masuk Anda dan masukkan kodenya di bawah.`)
};

const ms_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jika e-mel ini boleh dipautkan kepada akaun, kami telah menghantar kod pengaktifan. Semak peti masuk anda dan masukkannya di bawah.`)
};

const cs_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pokud lze tento e-mail přiřadit k účtu, poslali jsme aktivační kód. Zkontrolujte doručenou poštu a zadejte jej níže.`)
};

const el_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Αν αυτό το email μπορεί να συνδεθεί με λογαριασμό, σας στείλαμε κωδικό ενεργοποίησης. Ελέγξτε τα εισερχόμενά σας και εισαγάγετέ τον παρακάτω.`)
};

const he_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`אם ניתן לשייך את כתובת הדוא״ל הזו לחשבון, שלחנו קוד הגדרה. בדקו את תיבת הדואר הנכנס והזינו אותו למטה.`)
};

const af_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As hierdie e-posadres aan 'n rekening gekoppel kan word, het ons 'n opstelkode gestuur. Gaan jou inkassie na en voer dit hieronder in.`)
};

const hu_auth_toast_setup_code_sent = /** @type {(inputs: Auth_Toast_Setup_Code_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ha ez az e-mail-cím fiókhoz kapcsolható, elküldtük az aktiváló kódot. Nézze meg a beérkező leveleit, és adja meg alább.`)
};

/**
* | output |
* | --- |
* | "If this email can be claimed, we sent a setup code. Check your inbox and enter it below." |
*
* @param {Auth_Toast_Setup_Code_SentInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_toast_setup_code_sent = /** @type {((inputs?: Auth_Toast_Setup_Code_SentInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Toast_Setup_Code_SentInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_toast_setup_code_sent(inputs)
	if (locale === "de") return de_auth_toast_setup_code_sent(inputs)
	if (locale === "zh") return zh_auth_toast_setup_code_sent(inputs)
	if (locale === "ar") return ar_auth_toast_setup_code_sent(inputs)
	if (locale === "fr") return fr_auth_toast_setup_code_sent(inputs)
	if (locale === "vi") return vi_auth_toast_setup_code_sent(inputs)
	if (locale === "sw") return sw_auth_toast_setup_code_sent(inputs)
	if (locale === "th") return th_auth_toast_setup_code_sent(inputs)
	if (locale === "bs") return bs_auth_toast_setup_code_sent(inputs)
	if (locale === "ja") return ja_auth_toast_setup_code_sent(inputs)
	if (locale === "ko") return ko_auth_toast_setup_code_sent(inputs)
	if (locale === "pt") return pt_auth_toast_setup_code_sent(inputs)
	if (locale === "it") return it_auth_toast_setup_code_sent(inputs)
	if (locale === "sv") return sv_auth_toast_setup_code_sent(inputs)
	if (locale === "nl") return nl_auth_toast_setup_code_sent(inputs)
	if (locale === "da") return da_auth_toast_setup_code_sent(inputs)
	if (locale === "nb") return nb_auth_toast_setup_code_sent(inputs)
	if (locale === "fi") return fi_auth_toast_setup_code_sent(inputs)
	if (locale === "pl") return pl_auth_toast_setup_code_sent(inputs)
	if (locale === "ru") return ru_auth_toast_setup_code_sent(inputs)
	if (locale === "tr") return tr_auth_toast_setup_code_sent(inputs)
	if (locale === "hi") return hi_auth_toast_setup_code_sent(inputs)
	if (locale === "id") return id_auth_toast_setup_code_sent(inputs)
	if (locale === "ms") return ms_auth_toast_setup_code_sent(inputs)
	if (locale === "cs") return cs_auth_toast_setup_code_sent(inputs)
	if (locale === "el") return el_auth_toast_setup_code_sent(inputs)
	if (locale === "he") return he_auth_toast_setup_code_sent(inputs)
	if (locale === "af") return af_auth_toast_setup_code_sent(inputs)
	if (locale === "hu") return hu_auth_toast_setup_code_sent(inputs)
	return en_auth_toast_setup_code_sent(inputs)
});